import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/text1/page.tsx");
